import axios from "axios";
import { BASE_API_URL } from "../utils/api-url";

export async function getCompetitors(accessToken) {
  const result = await axios.get(`${BASE_API_URL}/competitors/500/1`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return result.data;
}

export async function createCompetitor(accessToken, name) {
  const result = await axios({
    method: "POST",
    url: `${BASE_API_URL}/competitors`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    data: { name },
  });

  return result;
}

export async function deleteCompetitor(accessToken, id) {
  const result = await axios({
    method: "DELETE",
    url: `${BASE_API_URL}/competitors/${id}`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return result;
}